/**
 * @desc 查询汇总库存信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockPool.summary.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/summary`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
